export const classes = {
  dialogActions: 'flex w-full justify-between items-end pb-6',
};
